import { useEffect } from "react";
import { Helmet } from "react-helmet"; // 👈 Import Helmet
import "./css/Index.css";
import { initScrollBehavior } from "./methods/scroll";
import HomeSection1 from "./subpages/home/home1";
import HomeSection12 from "./subpages/home/home1_2";
import HomeSection2 from "./subpages/home/home2";
import HomeSection3 from "./subpages/home/home3";
import Footer from "../footer";

function IndexPage() {
  useEffect(() => {
    const cleanup = initScrollBehavior("#home-sections", { isScrollable: true });
    return () => cleanup?.();
  }, []);

  return (
    <div className="container-fluid px-0" id="home-sections">
      <Helmet>
        <title>Voila Consulting</title>
        <meta name="description" content="Description of your page for SEO" />
      </Helmet>
      <HomeSection1 />
      <HomeSection12 />
      <HomeSection2 />
      <HomeSection3 />
      <Footer isScrollable={false} />
    </div>
  );
}

export default IndexPage;